var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNestCamWallMountBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1760_301",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.892578,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1760_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22599 14.5418C3.76766 14.5418 3.3753 14.3786 3.04891 14.0522C2.72252 13.7259 2.55933 13.3335 2.55933 12.8752V6.2085C2.55933 5.75016 2.72252 5.3578 3.04891 5.03141C3.3753 4.70502 3.76766 4.54183 4.22599 4.54183C4.68433 4.54183 5.07669 4.7085 5.40308 5.04183C5.72947 5.37516 5.89266 5.771 5.89266 6.22933C6.37877 5.46544 7.02113 4.85433 7.81974 4.396C8.61835 3.93766 9.50377 3.7085 10.476 3.7085C11.1982 3.7085 11.8892 3.84391 12.5489 4.11475C13.2086 4.38558 13.7954 4.77794 14.3093 5.29183L17.8927 8.87516C18.0593 9.04183 18.1843 9.22586 18.2677 9.42725C18.351 9.62864 18.3927 9.84044 18.3927 10.0627C18.3927 10.2849 18.351 10.4967 18.2677 10.6981C18.1843 10.8995 18.0593 11.0835 17.8927 11.2502L12.601 16.5418C12.4482 16.6946 12.2711 16.8127 12.0697 16.896C11.8684 16.9793 11.6565 17.021 11.4343 17.021C11.2121 17.021 10.9968 16.9793 10.7885 16.896C10.5802 16.8127 10.3996 16.6946 10.2468 16.5418L6.64266 12.9585C6.48988 12.8057 6.35447 12.6529 6.23641 12.5002C6.11835 12.3474 6.00377 12.1877 5.89266 12.021V12.8752C5.89266 13.3335 5.72947 13.7259 5.40308 14.0522C5.07669 14.3786 4.68433 14.5418 4.22599 14.5418Z",
    fill: "#1B4B86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNestCamWallMountBlue);
export default __webpack_public_path__ + "static/media/icon_nest_cam_wall_mount_blue.f2156d258ea2b2696ce0fb96a4e9a2a3.svg";
export { ForwardRef as ReactComponent };